import { NgModule } from '@angular/core';
import { MenuComponent } from './menu/menu';
import { IonicModule } from 'ionic-angular';
@NgModule({
	declarations: [MenuComponent],
	imports: [IonicModule],
	exports: [MenuComponent],
	entryComponents: [MenuComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts